<template>
  <div class="table-action-wrapper">
    <Select :options="statusOptions" placeholder="Status" data-title="Status" class="has-tip" :value="query?.status?.value" @changeValue="changeStatus"></Select>
    <Select source="user/search" type="auto" field="order.user_read" placeholder="User Login Parent" :value="query.user_id.value" @changeValue="changeUserId"></Select>
    <Select :options="loggedOptions" placeholder="Login Status" data-title="Login Status" class="has-tip" :value="query.logged.value" @changeValue="changeLogged"></Select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {
        status: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Status'
        },
        user_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'User'
        },
        logged: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Logged'
        }
      }
    }
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    statusOptions() {
      return Object.values(this.extraAttributes.status) || []
    },
    loggedOptions() {
      return this.extraAttributes.logged || []
    }
  },
  methods: {
    changeStatus(value, e) {
      this.query.status = Object.assign(this.query.status, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeLogged(value, e) {
      this.query.logged = Object.assign(this.query.logged, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeUserId(value, e) {
      this.query.user_id = Object.assign(this.query.user_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    }
  },
  props: {
    config: Object
  }
}
</script>
